import {Plugin} from '@ckeditor/ckeditor5-core';
import {ButtonView} from '@ckeditor/ckeditor5-ui';
import iconimg from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import iconvid from '@ckeditor/ckeditor5-media-embed/theme/icons/media.svg';

export default class SpUploader extends Plugin {
    spmanager;
    init() {
        const {t} = this.editor.locale;
        const editor = this.editor;
        this.spmanager = this.editor.config.get('SpUploader').manager.initBrowser(editor.id);
        const buttonImg = new ButtonView();
        const buttonVideo = new ButtonView();
        editor.ui.componentFactory.add('spuploaderImg', () => {
            buttonImg.label = t('Insert Image');
            buttonImg.tooltip = true;
            buttonImg.icon = iconimg;
            return buttonImg;
        });
        editor.ui.componentFactory.add('spuploaderVideo', () => {
            buttonVideo.label = t('Insert video');
            buttonVideo.tooltip = true;
            buttonVideo.icon = iconvid;
            return buttonVideo;
        });
        buttonImg.on('execute', () => {
            this.spmanager.openBrowser('image');
        });
        buttonVideo.on('execute', () => {
            this.spmanager.openBrowser('video');
        });
    }
}